import { getImagePositionAndMaskWithProductId } from '@webapp/utils/merch/imageAndMaskWithProductId';
import { MerchProduct } from '@services/merch/types/api/merch-product';

export const getMerchProductMask = (item: MerchProduct) => {
  const whiteProduct = item.colors.find(
    (color) => color.name?.toLowerCase() === 'white'
  );
  const colorsImageSrc =
    item.colors.find((color) => color?.images?.[0]?.src)?.images?.[0].src || '';
  const sizesImageSrc =
    item.sizes.find((size) => size?.images?.[0]?.src)?.images?.[0].src || '';

  return item.image
    ? item.image
    : whiteProduct
    ? whiteProduct.image || whiteProduct.images?.[0]?.src
    : colorsImageSrc
    ? colorsImageSrc
    : sizesImageSrc
    ? sizesImageSrc
    : getImagePositionAndMaskWithProductId(
        item.printify[0].itemId as number
      )[0];
};
